
define('text!templates/modules/note/note-edit-modal.html',[],function () { return '<div class="note-edit-chatbox"></div>\n';});

